import {action, getter, Module, mutation, VuexModule} from "vuex-class-component"
import {Notification, DebugNotification} from "@/interface"
import API from "@/api"

@Module({namespacedPath: "notification/"})
export default class NotificationModule extends VuexModule {

  @getter
  public notifications: Notification[] = []

  @getter
  public all_count: number = 1

  @mutation
  setNotifications(data: { notifications: Notification[], count: number }) {
    this.notifications = data.notifications
    this.all_count = data.count
  }

  @action()
  async fetchNotifications(payload: { force: boolean, page?: number, filter?: object }): Promise<void> {
    if (this.notifications.length === 0 || payload.force) {
      const notifications = await API.getNotifications({page: payload.page || 1, filter: payload.filter})
      this.setNotifications(notifications)
    }
  }

  @action()
  async fetchNotificationById(id: number): Promise<{ notification: Notification, sent_notifications: any[] }> {
    return await API.getNotification({id: id})
  }

  @action
  async create(notifications: Notification) {
    await API.createNotification(notifications)
    await this.fetchNotifications({force: true})
  }

  @action
  async debug(notification: DebugNotification) {
    await API.debugNotification(notification)
  }

  @action()
  async cancel(notification_id: number) {
    await API.cancelNotification({id: notification_id})
  }
}